import isString from 'lodash/isString';
import isUndefined from 'lodash/isUndefined';
export function getIsNewLabel({ embargoExternal, daysToShowNew, isNew, }) {
    let daysDiff;
    if (embargoExternal) {
        const embargoDate = isString(embargoExternal) ? Date.parse(embargoExternal) : embargoExternal;
        const currentDate = new Date();
        const timeDiff = currentDate.getTime() - embargoDate;
        daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    }
    // Note: ((embargoExternal + daysToShowNew) > current date); Necessary set-up param for daysToShowNew in AEM
    const isNewLabel = isNew ||
        (!isUndefined(daysToShowNew) && daysToShowNew > 0 && daysDiff && daysDiff <= daysToShowNew);
    return {
        isNewLabel,
    };
}
